var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "menu"
  }, /*#__PURE__*/React.createElement("g", {
    id: "close"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 1959",
    x: 14.3438,
    y: 12.9268,
    width: 18,
    height: 2,
    rx: 1,
    transform: "rotate(45 14.3438 12.9268)",
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 1958",
    x: 12.9297,
    y: 25.6572,
    width: 18,
    height: 2,
    rx: 1,
    transform: "rotate(-45 12.9297 25.6572)",
    fill: "black"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/close_icon.dbb241f2cc651cabe396602a3b760660.svg";
export { ForwardRef as ReactComponent };